(function webpackUniversalModuleDefinition(root, factory) {
    if(typeof exports === 'object' && typeof module === 'object')
        module.exports = factory(require("clappr"));
    else if(typeof define === 'function' && define.amd)
        define(["clappr"], factory);
    else if(typeof exports === 'object')
        exports["LevelSelector"] = factory(require("clappr"));
    else
        root["LevelSelector"] = factory(root["Clappr"]);
})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE_83__) {
    return /******/ (function(modules) { // webpackBootstrap
        /******/ 	// The module cache
        /******/ 	var installedModules = {};
        /******/
        /******/ 	// The require function
        /******/ 	function __webpack_require__(moduleId) {
            /******/
            /******/ 		// Check if module is in cache
            /******/ 		if(installedModules[moduleId]) {
                /******/ 			return installedModules[moduleId].exports;
                /******/ 		}
            /******/ 		// Create a new module (and put it into the cache)
            /******/ 		var module = installedModules[moduleId] = {
                /******/ 			i: moduleId,
                /******/ 			l: false,
                /******/ 			exports: {}
                /******/ 		};
            /******/
            /******/ 		// Execute the module function
            /******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
            /******/
            /******/ 		// Flag the module as loaded
            /******/ 		module.l = true;
            /******/
            /******/ 		// Return the exports of the module
            /******/ 		return module.exports;
            /******/ 	}
        /******/
        /******/
        /******/ 	// expose the modules object (__webpack_modules__)
        /******/ 	__webpack_require__.m = modules;
        /******/
        /******/ 	// expose the module cache
        /******/ 	__webpack_require__.c = installedModules;
        /******/
        /******/ 	// define getter function for harmony exports
        /******/ 	__webpack_require__.d = function(exports, name, getter) {
            /******/ 		if(!__webpack_require__.o(exports, name)) {
                /******/ 			Object.defineProperty(exports, name, {
                    /******/ 				configurable: false,
                    /******/ 				enumerable: true,
                    /******/ 				get: getter
                    /******/ 			});
                /******/ 		}
            /******/ 	};
        /******/
        /******/ 	// getDefaultExport function for compatibility with non-harmony modules
        /******/ 	__webpack_require__.n = function(module) {
            /******/ 		var getter = module && module.__esModule ?
                /******/ 			function getDefault() { return module['default']; } :
                /******/ 			function getModuleExports() { return module; };
            /******/ 		__webpack_require__.d(getter, 'a', getter);
            /******/ 		return getter;
            /******/ 	};
        /******/
        /******/ 	// Object.prototype.hasOwnProperty.call
        /******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
        /******/
        /******/ 	// __webpack_public_path__
        /******/ 	__webpack_require__.p = "<%=baseUrl%>/";
        /******/
        /******/ 	// Load entry module and return exports
        /******/ 	return __webpack_require__(__webpack_require__.s = 39);
        /******/ })
    /************************************************************************/
    /******/ ([
        /* 0 */
        /***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
            var global = module.exports = typeof window != 'undefined' && window.Math == Math
                ? window : typeof self != 'undefined' && self.Math == Math ? self
                    // eslint-disable-next-line no-new-func
                    : Function('return this')();
            if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


            /***/ }),
        /* 1 */
        /***/ (function(module, exports, __webpack_require__) {

            var anObject = __webpack_require__(10);
            var IE8_DOM_DEFINE = __webpack_require__(29);
            var toPrimitive = __webpack_require__(14);
            var dP = Object.defineProperty;

            exports.f = __webpack_require__(2) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
                anObject(O);
                P = toPrimitive(P, true);
                anObject(Attributes);
                if (IE8_DOM_DEFINE) try {
                    return dP(O, P, Attributes);
                } catch (e) { /* empty */ }
                if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
                if ('value' in Attributes) O[P] = Attributes.value;
                return O;
            };


            /***/ }),
        /* 2 */
        /***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
            module.exports = !__webpack_require__(11)(function () {
                return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
            });


            /***/ }),
        /* 3 */
        /***/ (function(module, exports) {

            var hasOwnProperty = {}.hasOwnProperty;
            module.exports = function (it, key) {
                return hasOwnProperty.call(it, key);
            };


            /***/ }),
        /* 4 */
        /***/ (function(module, exports) {

            var core = module.exports = { version: '2.5.5' };
            if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


            /***/ }),
        /* 5 */
        /***/ (function(module, exports, __webpack_require__) {

            var dP = __webpack_require__(1);
            var createDesc = __webpack_require__(12);
            module.exports = __webpack_require__(2) ? function (object, key, value) {
                return dP.f(object, key, createDesc(1, value));
            } : function (object, key, value) {
                object[key] = value;
                return object;
            };


            /***/ }),
        /* 6 */
        /***/ (function(module, exports) {

            module.exports = function (it) {
                return typeof it === 'object' ? it !== null : typeof it === 'function';
            };


            /***/ }),
        /* 7 */
        /***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
            var IObject = __webpack_require__(54);
            var defined = __webpack_require__(16);
            module.exports = function (it) {
                return IObject(defined(it));
            };


            /***/ }),
        /* 8 */
        /***/ (function(module, exports, __webpack_require__) {

            var store = __webpack_require__(22)('wks');
            var uid = __webpack_require__(13);
            var Symbol = __webpack_require__(0).Symbol;
            var USE_SYMBOL = typeof Symbol == 'function';

            var $exports = module.exports = function (name) {
                return store[name] || (store[name] =
                    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
            };

            $exports.store = store;


            /***/ }),
        /* 9 */
        /***/ (function(module, exports, __webpack_require__) {

            var global = __webpack_require__(0);
            var core = __webpack_require__(4);
            var ctx = __webpack_require__(28);
            var hide = __webpack_require__(5);
            var has = __webpack_require__(3);
            var PROTOTYPE = 'prototype';

            var $export = function (type, name, source) {
                var IS_FORCED = type & $export.F;
                var IS_GLOBAL = type & $export.G;
                var IS_STATIC = type & $export.S;
                var IS_PROTO = type & $export.P;
                var IS_BIND = type & $export.B;
                var IS_WRAP = type & $export.W;
                var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
                var expProto = exports[PROTOTYPE];
                var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
                var key, own, out;
                if (IS_GLOBAL) source = name;
                for (key in source) {
                    // contains in native
                    own = !IS_FORCED && target && target[key] !== undefined;
                    if (own && has(exports, key)) continue;
                    // export native or passed
                    out = own ? target[key] : source[key];
                    // prevent global pollution for namespaces
                    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
                        // bind timers to global for call from export context
                        : IS_BIND && own ? ctx(out, global)
                            // wrap global constructors for prevent change them in library
                            : IS_WRAP && target[key] == out ? (function (C) {
                                var F = function (a, b, c) {
                                    if (this instanceof C) {
                                        switch (arguments.length) {
                                            case 0: return new C();
                                            case 1: return new C(a);
                                            case 2: return new C(a, b);
                                        } return new C(a, b, c);
                                    } return C.apply(this, arguments);
                                };
                                F[PROTOTYPE] = C[PROTOTYPE];
                                return F;
                                // make static versions for prototype methods
                            })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
                    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
                    if (IS_PROTO) {
                        (exports.virtual || (exports.virtual = {}))[key] = out;
                        // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
                        if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
                    }
                }
            };
// type bitmap
            $export.F = 1;   // forced
            $export.G = 2;   // global
            $export.S = 4;   // static
            $export.P = 8;   // proto
            $export.B = 16;  // bind
            $export.W = 32;  // wrap
            $export.U = 64;  // safe
            $export.R = 128; // real proto method for `library`
            module.exports = $export;


            /***/ }),
        /* 10 */
        /***/ (function(module, exports, __webpack_require__) {

            var isObject = __webpack_require__(6);
            module.exports = function (it) {
                if (!isObject(it)) throw TypeError(it + ' is not an object!');
                return it;
            };


            /***/ }),
        /* 11 */
        /***/ (function(module, exports) {

            module.exports = function (exec) {
                try {
                    return !!exec();
                } catch (e) {
                    return true;
                }
            };


            /***/ }),
        /* 12 */
        /***/ (function(module, exports) {

            module.exports = function (bitmap, value) {
                return {
                    enumerable: !(bitmap & 1),
                    configurable: !(bitmap & 2),
                    writable: !(bitmap & 4),
                    value: value
                };
            };


            /***/ }),
        /* 13 */
        /***/ (function(module, exports) {

            var id = 0;
            var px = Math.random();
            module.exports = function (key) {
                return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
            };


            /***/ }),
        /* 14 */
        /***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
            var isObject = __webpack_require__(6);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
            module.exports = function (it, S) {
                if (!isObject(it)) return it;
                var fn, val;
                if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
                if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
                if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
                throw TypeError("Can't convert object to primitive value");
            };


            /***/ }),
        /* 15 */
        /***/ (function(module, exports) {

// 7.1.4 ToInteger
            var ceil = Math.ceil;
            var floor = Math.floor;
            module.exports = function (it) {
                return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
            };


            /***/ }),
        /* 16 */
        /***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
            module.exports = function (it) {
                if (it == undefined) throw TypeError("Can't call method on  " + it);
                return it;
            };


            /***/ }),
        /* 17 */
        /***/ (function(module, exports) {

            module.exports = true;


            /***/ }),
        /* 18 */
        /***/ (function(module, exports) {

            module.exports = {};


            /***/ }),
        /* 19 */
        /***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
            var anObject = __webpack_require__(10);
            var dPs = __webpack_require__(53);
            var enumBugKeys = __webpack_require__(23);
            var IE_PROTO = __webpack_require__(21)('IE_PROTO');
            var Empty = function () { /* empty */ };
            var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
            var createDict = function () {
                // Thrash, waste and sodomy: IE GC bug
                var iframe = __webpack_require__(30)('iframe');
                var i = enumBugKeys.length;
                var lt = '<';
                var gt = '>';
                var iframeDocument;
                iframe.style.display = 'none';
                __webpack_require__(58).appendChild(iframe);
                iframe.src = 'javascript:'; // eslint-disable-line no-script-url
                // createDict = iframe.contentWindow.Object;
                // html.removeChild(iframe);
                iframeDocument = iframe.contentWindow.document;
                iframeDocument.open();
                iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
                iframeDocument.close();
                createDict = iframeDocument.F;
                while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
                return createDict();
            };

            module.exports = Object.create || function create(O, Properties) {
                var result;
                if (O !== null) {
                    Empty[PROTOTYPE] = anObject(O);
                    result = new Empty();
                    Empty[PROTOTYPE] = null;
                    // add "__proto__" for Object.getPrototypeOf polyfill
                    result[IE_PROTO] = O;
                } else result = createDict();
                return Properties === undefined ? result : dPs(result, Properties);
            };


            /***/ }),
        /* 20 */
        /***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
            var $keys = __webpack_require__(34);
            var enumBugKeys = __webpack_require__(23);

            module.exports = Object.keys || function keys(O) {
                return $keys(O, enumBugKeys);
            };


            /***/ }),
        /* 21 */
        /***/ (function(module, exports, __webpack_require__) {

            var shared = __webpack_require__(22)('keys');
            var uid = __webpack_require__(13);
            module.exports = function (key) {
                return shared[key] || (shared[key] = uid(key));
            };


            /***/ }),
        /* 22 */
        /***/ (function(module, exports, __webpack_require__) {

            var global = __webpack_require__(0);
            var SHARED = '__core-js_shared__';
            var store = global[SHARED] || (global[SHARED] = {});
            module.exports = function (key) {
                return store[key] || (store[key] = {});
            };


            /***/ }),
        /* 23 */
        /***/ (function(module, exports) {

// IE 8- don't enum bug keys
            module.exports = (
                'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
            ).split(',');


            /***/ }),
        /* 24 */
        /***/ (function(module, exports, __webpack_require__) {

            var def = __webpack_require__(1).f;
            var has = __webpack_require__(3);
            var TAG = __webpack_require__(8)('toStringTag');

            module.exports = function (it, tag, stat) {
                if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
            };


            /***/ }),
        /* 25 */
        /***/ (function(module, exports, __webpack_require__) {

            exports.f = __webpack_require__(8);


            /***/ }),
        /* 26 */
        /***/ (function(module, exports, __webpack_require__) {

            var global = __webpack_require__(0);
            var core = __webpack_require__(4);
            var LIBRARY = __webpack_require__(17);
            var wksExt = __webpack_require__(25);
            var defineProperty = __webpack_require__(1).f;
            module.exports = function (name) {
                var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
                if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
            };


            /***/ }),
        /* 27 */
        /***/ (function(module, exports) {

            exports.f = {}.propertyIsEnumerable;


            /***/ }),
        /* 28 */
        /***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
            var aFunction = __webpack_require__(46);
            module.exports = function (fn, that, length) {
                aFunction(fn);
                if (that === undefined) return fn;
                switch (length) {
                    case 1: return function (a) {
                        return fn.call(that, a);
                    };
                    case 2: return function (a, b) {
                        return fn.call(that, a, b);
                    };
                    case 3: return function (a, b, c) {
                        return fn.call(that, a, b, c);
                    };
                }
                return function (/* ...args */) {
                    return fn.apply(that, arguments);
                };
            };


            /***/ }),
        /* 29 */
        /***/ (function(module, exports, __webpack_require__) {

            module.exports = !__webpack_require__(2) && !__webpack_require__(11)(function () {
                return Object.defineProperty(__webpack_require__(30)('div'), 'a', { get: function () { return 7; } }).a != 7;
            });


            /***/ }),
        /* 30 */
        /***/ (function(module, exports, __webpack_require__) {

            var isObject = __webpack_require__(6);
            var document = __webpack_require__(0).document;
// typeof document.createElement is 'object' in old IE
            var is = isObject(document) && isObject(document.createElement);
            module.exports = function (it) {
                return is ? document.createElement(it) : {};
            };


            /***/ }),
        /* 31 */
        /***/ (function(module, exports, __webpack_require__) {

            "use strict";


            exports.__esModule = true;

            var _iterator = __webpack_require__(48);

            var _iterator2 = _interopRequireDefault(_iterator);

            var _symbol = __webpack_require__(65);

            var _symbol2 = _interopRequireDefault(_symbol);

            var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

            function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

            exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
                return typeof obj === "undefined" ? "undefined" : _typeof(obj);
            } : function (obj) {
                return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
            };

            /***/ }),
        /* 32 */
        /***/ (function(module, exports, __webpack_require__) {

            "use strict";

            var LIBRARY = __webpack_require__(17);
            var $export = __webpack_require__(9);
            var redefine = __webpack_require__(33);
            var hide = __webpack_require__(5);
            var Iterators = __webpack_require__(18);
            var $iterCreate = __webpack_require__(52);
            var setToStringTag = __webpack_require__(24);
            var getPrototypeOf = __webpack_require__(59);
            var ITERATOR = __webpack_require__(8)('iterator');
            var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
            var FF_ITERATOR = '@@iterator';
            var KEYS = 'keys';
            var VALUES = 'values';

            var returnThis = function () { return this; };

            module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
                $iterCreate(Constructor, NAME, next);
                var getMethod = function (kind) {
                    if (!BUGGY && kind in proto) return proto[kind];
                    switch (kind) {
                        case KEYS: return function keys() { return new Constructor(this, kind); };
                        case VALUES: return function values() { return new Constructor(this, kind); };
                    } return function entries() { return new Constructor(this, kind); };
                };
                var TAG = NAME + ' Iterator';
                var DEF_VALUES = DEFAULT == VALUES;
                var VALUES_BUG = false;
                var proto = Base.prototype;
                var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
                var $default = $native || getMethod(DEFAULT);
                var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
                var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
                var methods, key, IteratorPrototype;
                // Fix native
                if ($anyNative) {
                    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
                    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
                        // Set @@toStringTag to native iterators
                        setToStringTag(IteratorPrototype, TAG, true);
                        // fix for some old engines
                        if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
                    }
                }
                // fix Array#{values, @@iterator}.name in V8 / FF
                if (DEF_VALUES && $native && $native.name !== VALUES) {
                    VALUES_BUG = true;
                    $default = function values() { return $native.call(this); };
                }
                // Define iterator
                if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
                    hide(proto, ITERATOR, $default);
                }
                // Plug for library
                Iterators[NAME] = $default;
                Iterators[TAG] = returnThis;
                if (DEFAULT) {
                    methods = {
                        values: DEF_VALUES ? $default : getMethod(VALUES),
                        keys: IS_SET ? $default : getMethod(KEYS),
                        entries: $entries
                    };
                    if (FORCED) for (key in methods) {
                        if (!(key in proto)) redefine(proto, key, methods[key]);
                    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
                }
                return methods;
            };


            /***/ }),
        /* 33 */
        /***/ (function(module, exports, __webpack_require__) {

            module.exports = __webpack_require__(5);


            /***/ }),
        /* 34 */
        /***/ (function(module, exports, __webpack_require__) {

            var has = __webpack_require__(3);
            var toIObject = __webpack_require__(7);
            var arrayIndexOf = __webpack_require__(55)(false);
            var IE_PROTO = __webpack_require__(21)('IE_PROTO');

            module.exports = function (object, names) {
                var O = toIObject(object);
                var i = 0;
                var result = [];
                var key;
                for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
                // Don't enum bug & hidden keys
                while (names.length > i) if (has(O, key = names[i++])) {
                    ~arrayIndexOf(result, key) || result.push(key);
                }
                return result;
            };


            /***/ }),
        /* 35 */
        /***/ (function(module, exports) {

            var toString = {}.toString;

            module.exports = function (it) {
                return toString.call(it).slice(8, -1);
            };


            /***/ }),
        /* 36 */
        /***/ (function(module, exports) {

            exports.f = Object.getOwnPropertySymbols;


            /***/ }),
        /* 37 */
        /***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
            var $keys = __webpack_require__(34);
            var hiddenKeys = __webpack_require__(23).concat('length', 'prototype');

            exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
                return $keys(O, hiddenKeys);
            };


            /***/ }),
        /* 38 */
        /***/ (function(module, exports, __webpack_require__) {

            var pIE = __webpack_require__(27);
            var createDesc = __webpack_require__(12);
            var toIObject = __webpack_require__(7);
            var toPrimitive = __webpack_require__(14);
            var has = __webpack_require__(3);
            var IE8_DOM_DEFINE = __webpack_require__(29);
            var gOPD = Object.getOwnPropertyDescriptor;

            exports.f = __webpack_require__(2) ? gOPD : function getOwnPropertyDescriptor(O, P) {
                O = toIObject(O);
                P = toPrimitive(P, true);
                if (IE8_DOM_DEFINE) try {
                    return gOPD(O, P);
                } catch (e) { /* empty */ }
                if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
            };


            /***/ }),
        /* 39 */
        /***/ (function(module, exports, __webpack_require__) {

            "use strict";
            Object.defineProperty(exports,"__esModule",{value:true});var _main=__webpack_require__(40);var _main2=_interopRequireDefault(_main);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}exports.default=_main2.default;module.exports=exports['default'];

            /***/ }),
        /* 40 */
        /***/ (function(module, exports, __webpack_require__) {

            "use strict";
            Object.defineProperty(exports,"__esModule",{value:true});var _classCallCheck2=__webpack_require__(41);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(42);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(47);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(75);var _inherits3=_interopRequireDefault(_inherits2);var _clappr=__webpack_require__(83);var _levelSelector=__webpack_require__(84);var _levelSelector2=_interopRequireDefault(_levelSelector);var _style=__webpack_require__(85);var _style2=_interopRequireDefault(_style);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var AUTO=-1;var LevelSelector=function(_UICorePlugin){(0,_inherits3.default)(LevelSelector,_UICorePlugin);function LevelSelector(){(0,_classCallCheck3.default)(this,LevelSelector);return(0,_possibleConstructorReturn3.default)(this,_UICorePlugin.apply(this,arguments));}LevelSelector.prototype.bindEvents=function bindEvents(){this.listenTo(this.core,_clappr.Events.CORE_READY,this.bindPlaybackEvents);this.listenTo(this.core.mediaControl,_clappr.Events.MEDIACONTROL_CONTAINERCHANGED,this.reload);this.listenTo(this.core.mediaControl,_clappr.Events.MEDIACONTROL_RENDERED,this.render);this.listenTo(this.core.mediaControl,_clappr.Events.MEDIACONTROL_HIDE,this.hideSelectLevelMenu);};LevelSelector.prototype.unBindEvents=function unBindEvents(){this.stopListening(this.core,_clappr.Events.CORE_READY);this.stopListening(this.core.mediaControl,_clappr.Events.MEDIACONTROL_CONTAINERCHANGED);this.stopListening(this.core.mediaControl,_clappr.Events.MEDIACONTROL_RENDERED);this.stopListening(this.core.mediaControl,_clappr.Events.MEDIACONTROL_HIDE);this.stopListening(this.core.getCurrentPlayback(),_clappr.Events.PLAYBACK_LEVELS_AVAILABLE);this.stopListening(this.core.getCurrentPlayback(),_clappr.Events.PLAYBACK_LEVEL_SWITCH_START);this.stopListening(this.core.getCurrentPlayback(),_clappr.Events.PLAYBACK_LEVEL_SWITCH_END);this.stopListening(this.core.getCurrentPlayback(),_clappr.Events.PLAYBACK_BITRATE);};LevelSelector.prototype.bindPlaybackEvents=function bindPlaybackEvents(){var currentPlayback=this.core.getCurrentPlayback();this.listenTo(currentPlayback,_clappr.Events.PLAYBACK_LEVELS_AVAILABLE,this.fillLevels);this.listenTo(currentPlayback,_clappr.Events.PLAYBACK_LEVEL_SWITCH_START,this.startLevelSwitch);this.listenTo(currentPlayback,_clappr.Events.PLAYBACK_LEVEL_SWITCH_END,this.stopLevelSwitch);this.listenTo(currentPlayback,_clappr.Events.PLAYBACK_BITRATE,this.updateCurrentLevel);var playbackLevelsAvaialbeWasTriggered=currentPlayback.levels&&currentPlayback.levels.length>0;playbackLevelsAvaialbeWasTriggered&&this.fillLevels(currentPlayback.levels);};LevelSelector.prototype.reload=function reload(){this.unBindEvents();this.bindEvents();this.bindPlaybackEvents();};LevelSelector.prototype.shouldRender=function shouldRender(){if(!this.core.getCurrentContainer())return false;var currentPlayback=this.core.getCurrentPlayback();if(!currentPlayback)return false;var respondsToCurrentLevel=currentPlayback.currentLevel!==undefined;// Only care if we have at least 2 to choose from
                var hasLevels=!!(this.levels&&this.levels.length>1);return respondsToCurrentLevel&&hasLevels;};LevelSelector.prototype.render=function render(){if(this.shouldRender()){var style=_clappr.Styler.getStyleFor(_style2.default,{baseUrl:this.core.options.baseUrl});this.$el.html(this.template({'levels':this.levels,'title':this.getTitle()}));this.$el.append(style);this.core.mediaControl.$('.media-control-right-panel').append(this.el);this.highlightCurrentLevel();}return this;};LevelSelector.prototype.fillLevels=function fillLevels(levels){var initialLevel=arguments.length>1&&arguments[1]!==undefined?arguments[1]:AUTO;if(this.selectedLevelId===undefined)this.selectedLevelId=initialLevel;this.levels=levels;this.configureLevelsLabels();this.render();};LevelSelector.prototype.configureLevelsLabels=function configureLevelsLabels(){if(this.core.options.levelSelectorConfig===undefined)return;var labelCallback=this.core.options.levelSelectorConfig.labelCallback;if(labelCallback&&typeof labelCallback!=='function')throw new TypeError('labelCallback must be a function');var hasLabels=this.core.options.levelSelectorConfig.labels;var labels=hasLabels?this.core.options.levelSelectorConfig.labels:{};if(labelCallback||hasLabels){var level=void 0;var label=void 0;for(var levelId in this.levels){level=this.levels[levelId];label=labels[level.id];if(labelCallback)level.label=labelCallback(level,label);else if(label)level.label=label;}}};LevelSelector.prototype.findLevelBy=function findLevelBy(id){var foundLevel=void 0;this.levels.forEach(function(level){if(level.id===id)foundLevel=level;});return foundLevel;};LevelSelector.prototype.onLevelSelect=function onLevelSelect(event){this.selectedLevelId=parseInt(event.target.dataset.levelSelectorSelect,10);if(this.core.getCurrentPlayback().currentLevel==this.selectedLevelId)return false;this.core.getCurrentPlayback().currentLevel=this.selectedLevelId;this.toggleContextMenu();event.stopPropagation();return false;};LevelSelector.prototype.onShowLevelSelectMenu=function onShowLevelSelectMenu(){this.toggleContextMenu();};LevelSelector.prototype.hideSelectLevelMenu=function hideSelectLevelMenu(){this.$('.level_selector ul').hide();};LevelSelector.prototype.toggleContextMenu=function toggleContextMenu(){this.$('.level_selector ul').toggle();};LevelSelector.prototype.buttonElement=function buttonElement(){return this.$('.level_selector button');};LevelSelector.prototype.levelElement=function levelElement(id){return this.$('.level_selector ul a'+(!isNaN(id)?'[data-level-selector-select="'+id+'"]':'')).parent();};LevelSelector.prototype.getTitle=function getTitle(){return(this.core.options.levelSelectorConfig||{}).title;};LevelSelector.prototype.startLevelSwitch=function startLevelSwitch(){this.buttonElement().addClass('changing');};LevelSelector.prototype.stopLevelSwitch=function stopLevelSwitch(){this.buttonElement().removeClass('changing');};LevelSelector.prototype.updateText=function updateText(level){if(level===AUTO)this.buttonElement().text(this.currentLevel?'AUTO ('+this.currentLevel.label+')':'AUTO');else this.buttonElement().text(this.findLevelBy(level).label);};LevelSelector.prototype.updateCurrentLevel=function updateCurrentLevel(info){var level=this.findLevelBy(info.level);this.currentLevel=level?level:null;this.highlightCurrentLevel();};LevelSelector.prototype.highlightCurrentLevel=function highlightCurrentLevel(){this.levelElement().removeClass('current');this.currentLevel&&this.levelElement(this.currentLevel.id).addClass('current');this.updateText(this.selectedLevelId);};(0,_createClass3.default)(LevelSelector,[{key:'name',get:function get(){return'level_selector';}},{key:'template',get:function get(){return(0,_clappr.template)(_levelSelector2.default);}},{key:'attributes',get:function get(){return{'class':this.name,'data-level-selector':''};}},{key:'events',get:function get(){return{'click [data-level-selector-select]':'onLevelSelect','click [data-level-selector-button]':'onShowLevelSelectMenu'};}}],[{key:'version',get:function get(){return VERSION;}}]);return LevelSelector;}(_clappr.UICorePlugin);exports.default=LevelSelector;module.exports=exports['default'];

            /***/ }),
        /* 41 */
        /***/ (function(module, exports, __webpack_require__) {

            "use strict";


            exports.__esModule = true;

            exports.default = function (instance, Constructor) {
                if (!(instance instanceof Constructor)) {
                    throw new TypeError("Cannot call a class as a function");
                }
            };

            /***/ }),
        /* 42 */
        /***/ (function(module, exports, __webpack_require__) {

            "use strict";


            exports.__esModule = true;

            var _defineProperty = __webpack_require__(43);

            var _defineProperty2 = _interopRequireDefault(_defineProperty);

            function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

            exports.default = function () {
                function defineProperties(target, props) {
                    for (var i = 0; i < props.length; i++) {
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        (0, _defineProperty2.default)(target, descriptor.key, descriptor);
                    }
                }

                return function (Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();

            /***/ }),
        /* 43 */
        /***/ (function(module, exports, __webpack_require__) {

            module.exports = { "default": __webpack_require__(44), __esModule: true };

            /***/ }),
        /* 44 */
        /***/ (function(module, exports, __webpack_require__) {

            __webpack_require__(45);
            var $Object = __webpack_require__(4).Object;
            module.exports = function defineProperty(it, key, desc) {
                return $Object.defineProperty(it, key, desc);
            };


            /***/ }),
        /* 45 */
        /***/ (function(module, exports, __webpack_require__) {

            var $export = __webpack_require__(9);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
            $export($export.S + $export.F * !__webpack_require__(2), 'Object', { defineProperty: __webpack_require__(1).f });


            /***/ }),
        /* 46 */
        /***/ (function(module, exports) {

            module.exports = function (it) {
                if (typeof it != 'function') throw TypeError(it + ' is not a function!');
                return it;
            };


            /***/ }),
        /* 47 */
        /***/ (function(module, exports, __webpack_require__) {

            "use strict";


            exports.__esModule = true;

            var _typeof2 = __webpack_require__(31);

            var _typeof3 = _interopRequireDefault(_typeof2);

            function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

            exports.default = function (self, call) {
                if (!self) {
                    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                }

                return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
            };

            /***/ }),
        /* 48 */
        /***/ (function(module, exports, __webpack_require__) {

            module.exports = { "default": __webpack_require__(49), __esModule: true };

            /***/ }),
        /* 49 */
        /***/ (function(module, exports, __webpack_require__) {

            __webpack_require__(50);
            __webpack_require__(61);
            module.exports = __webpack_require__(25).f('iterator');


            /***/ }),
        /* 50 */
        /***/ (function(module, exports, __webpack_require__) {

            "use strict";

            var $at = __webpack_require__(51)(true);

// 21.1.3.27 String.prototype[@@iterator]()
            __webpack_require__(32)(String, 'String', function (iterated) {
                this._t = String(iterated); // target
                this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
            }, function () {
                var O = this._t;
                var index = this._i;
                var point;
                if (index >= O.length) return { value: undefined, done: true };
                point = $at(O, index);
                this._i += point.length;
                return { value: point, done: false };
            });


            /***/ }),
        /* 51 */
        /***/ (function(module, exports, __webpack_require__) {

            var toInteger = __webpack_require__(15);
            var defined = __webpack_require__(16);
// true  -> String#at
// false -> String#codePointAt
            module.exports = function (TO_STRING) {
                return function (that, pos) {
                    var s = String(defined(that));
                    var i = toInteger(pos);
                    var l = s.length;
                    var a, b;
                    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
                    a = s.charCodeAt(i);
                    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
                        ? TO_STRING ? s.charAt(i) : a
                        : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
                };
            };


            /***/ }),
        /* 52 */
        /***/ (function(module, exports, __webpack_require__) {

            "use strict";

            var create = __webpack_require__(19);
            var descriptor = __webpack_require__(12);
            var setToStringTag = __webpack_require__(24);
            var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
            __webpack_require__(5)(IteratorPrototype, __webpack_require__(8)('iterator'), function () { return this; });

            module.exports = function (Constructor, NAME, next) {
                Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
                setToStringTag(Constructor, NAME + ' Iterator');
            };


            /***/ }),
        /* 53 */
        /***/ (function(module, exports, __webpack_require__) {

            var dP = __webpack_require__(1);
            var anObject = __webpack_require__(10);
            var getKeys = __webpack_require__(20);

            module.exports = __webpack_require__(2) ? Object.defineProperties : function defineProperties(O, Properties) {
                anObject(O);
                var keys = getKeys(Properties);
                var length = keys.length;
                var i = 0;
                var P;
                while (length > i) dP.f(O, P = keys[i++], Properties[P]);
                return O;
            };


            /***/ }),
        /* 54 */
        /***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
            var cof = __webpack_require__(35);
// eslint-disable-next-line no-prototype-builtins
            module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
                return cof(it) == 'String' ? it.split('') : Object(it);
            };


            /***/ }),
        /* 55 */
        /***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
            var toIObject = __webpack_require__(7);
            var toLength = __webpack_require__(56);
            var toAbsoluteIndex = __webpack_require__(57);
            module.exports = function (IS_INCLUDES) {
                return function ($this, el, fromIndex) {
                    var O = toIObject($this);
                    var length = toLength(O.length);
                    var index = toAbsoluteIndex(fromIndex, length);
                    var value;
                    // Array#includes uses SameValueZero equality algorithm
                    // eslint-disable-next-line no-self-compare
                    if (IS_INCLUDES && el != el) while (length > index) {
                        value = O[index++];
                        // eslint-disable-next-line no-self-compare
                        if (value != value) return true;
                        // Array#indexOf ignores holes, Array#includes - not
                    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
                        if (O[index] === el) return IS_INCLUDES || index || 0;
                    } return !IS_INCLUDES && -1;
                };
            };


            /***/ }),
        /* 56 */
        /***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
            var toInteger = __webpack_require__(15);
            var min = Math.min;
            module.exports = function (it) {
                return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
            };


            /***/ }),
        /* 57 */
        /***/ (function(module, exports, __webpack_require__) {

            var toInteger = __webpack_require__(15);
            var max = Math.max;
            var min = Math.min;
            module.exports = function (index, length) {
                index = toInteger(index);
                return index < 0 ? max(index + length, 0) : min(index, length);
            };


            /***/ }),
        /* 58 */
        /***/ (function(module, exports, __webpack_require__) {

            var document = __webpack_require__(0).document;
            module.exports = document && document.documentElement;


            /***/ }),
        /* 59 */
        /***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
            var has = __webpack_require__(3);
            var toObject = __webpack_require__(60);
            var IE_PROTO = __webpack_require__(21)('IE_PROTO');
            var ObjectProto = Object.prototype;

            module.exports = Object.getPrototypeOf || function (O) {
                O = toObject(O);
                if (has(O, IE_PROTO)) return O[IE_PROTO];
                if (typeof O.constructor == 'function' && O instanceof O.constructor) {
                    return O.constructor.prototype;
                } return O instanceof Object ? ObjectProto : null;
            };


            /***/ }),
        /* 60 */
        /***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
            var defined = __webpack_require__(16);
            module.exports = function (it) {
                return Object(defined(it));
            };


            /***/ }),
        /* 61 */
        /***/ (function(module, exports, __webpack_require__) {

            __webpack_require__(62);
            var global = __webpack_require__(0);
            var hide = __webpack_require__(5);
            var Iterators = __webpack_require__(18);
            var TO_STRING_TAG = __webpack_require__(8)('toStringTag');

            var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
                'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
                'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
                'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
                'TextTrackList,TouchList').split(',');

            for (var i = 0; i < DOMIterables.length; i++) {
                var NAME = DOMIterables[i];
                var Collection = global[NAME];
                var proto = Collection && Collection.prototype;
                if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
                Iterators[NAME] = Iterators.Array;
            }


            /***/ }),
        /* 62 */
        /***/ (function(module, exports, __webpack_require__) {

            "use strict";

            var addToUnscopables = __webpack_require__(63);
            var step = __webpack_require__(64);
            var Iterators = __webpack_require__(18);
            var toIObject = __webpack_require__(7);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
            module.exports = __webpack_require__(32)(Array, 'Array', function (iterated, kind) {
                this._t = toIObject(iterated); // target
                this._i = 0;                   // next index
                this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
            }, function () {
                var O = this._t;
                var kind = this._k;
                var index = this._i++;
                if (!O || index >= O.length) {
                    this._t = undefined;
                    return step(1);
                }
                if (kind == 'keys') return step(0, index);
                if (kind == 'values') return step(0, O[index]);
                return step(0, [index, O[index]]);
            }, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
            Iterators.Arguments = Iterators.Array;

            addToUnscopables('keys');
            addToUnscopables('values');
            addToUnscopables('entries');


            /***/ }),
        /* 63 */
        /***/ (function(module, exports) {

            module.exports = function () { /* empty */ };


            /***/ }),
        /* 64 */
        /***/ (function(module, exports) {

            module.exports = function (done, value) {
                return { value: value, done: !!done };
            };


            /***/ }),
        /* 65 */
        /***/ (function(module, exports, __webpack_require__) {

            module.exports = { "default": __webpack_require__(66), __esModule: true };

            /***/ }),
        /* 66 */
        /***/ (function(module, exports, __webpack_require__) {

            __webpack_require__(67);
            __webpack_require__(72);
            __webpack_require__(73);
            __webpack_require__(74);
            module.exports = __webpack_require__(4).Symbol;


            /***/ }),
        /* 67 */
        /***/ (function(module, exports, __webpack_require__) {

            "use strict";

// ECMAScript 6 symbols shim
            var global = __webpack_require__(0);
            var has = __webpack_require__(3);
            var DESCRIPTORS = __webpack_require__(2);
            var $export = __webpack_require__(9);
            var redefine = __webpack_require__(33);
            var META = __webpack_require__(68).KEY;
            var $fails = __webpack_require__(11);
            var shared = __webpack_require__(22);
            var setToStringTag = __webpack_require__(24);
            var uid = __webpack_require__(13);
            var wks = __webpack_require__(8);
            var wksExt = __webpack_require__(25);
            var wksDefine = __webpack_require__(26);
            var enumKeys = __webpack_require__(69);
            var isArray = __webpack_require__(70);
            var anObject = __webpack_require__(10);
            var isObject = __webpack_require__(6);
            var toIObject = __webpack_require__(7);
            var toPrimitive = __webpack_require__(14);
            var createDesc = __webpack_require__(12);
            var _create = __webpack_require__(19);
            var gOPNExt = __webpack_require__(71);
            var $GOPD = __webpack_require__(38);
            var $DP = __webpack_require__(1);
            var $keys = __webpack_require__(20);
            var gOPD = $GOPD.f;
            var dP = $DP.f;
            var gOPN = gOPNExt.f;
            var $Symbol = global.Symbol;
            var $JSON = global.JSON;
            var _stringify = $JSON && $JSON.stringify;
            var PROTOTYPE = 'prototype';
            var HIDDEN = wks('_hidden');
            var TO_PRIMITIVE = wks('toPrimitive');
            var isEnum = {}.propertyIsEnumerable;
            var SymbolRegistry = shared('symbol-registry');
            var AllSymbols = shared('symbols');
            var OPSymbols = shared('op-symbols');
            var ObjectProto = Object[PROTOTYPE];
            var USE_NATIVE = typeof $Symbol == 'function';
            var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
            var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
            var setSymbolDesc = DESCRIPTORS && $fails(function () {
                return _create(dP({}, 'a', {
                    get: function () { return dP(this, 'a', { value: 7 }).a; }
                })).a != 7;
            }) ? function (it, key, D) {
                var protoDesc = gOPD(ObjectProto, key);
                if (protoDesc) delete ObjectProto[key];
                dP(it, key, D);
                if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
            } : dP;

            var wrap = function (tag) {
                var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
                sym._k = tag;
                return sym;
            };

            var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
                return typeof it == 'symbol';
            } : function (it) {
                return it instanceof $Symbol;
            };

            var $defineProperty = function defineProperty(it, key, D) {
                if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
                anObject(it);
                key = toPrimitive(key, true);
                anObject(D);
                if (has(AllSymbols, key)) {
                    if (!D.enumerable) {
                        if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
                        it[HIDDEN][key] = true;
                    } else {
                        if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
                        D = _create(D, { enumerable: createDesc(0, false) });
                    } return setSymbolDesc(it, key, D);
                } return dP(it, key, D);
            };
            var $defineProperties = function defineProperties(it, P) {
                anObject(it);
                var keys = enumKeys(P = toIObject(P));
                var i = 0;
                var l = keys.length;
                var key;
                while (l > i) $defineProperty(it, key = keys[i++], P[key]);
                return it;
            };
            var $create = function create(it, P) {
                return P === undefined ? _create(it) : $defineProperties(_create(it), P);
            };
            var $propertyIsEnumerable = function propertyIsEnumerable(key) {
                var E = isEnum.call(this, key = toPrimitive(key, true));
                if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
                return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
            };
            var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
                it = toIObject(it);
                key = toPrimitive(key, true);
                if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
                var D = gOPD(it, key);
                if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
                return D;
            };
            var $getOwnPropertyNames = function getOwnPropertyNames(it) {
                var names = gOPN(toIObject(it));
                var result = [];
                var i = 0;
                var key;
                while (names.length > i) {
                    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
                } return result;
            };
            var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
                var IS_OP = it === ObjectProto;
                var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
                var result = [];
                var i = 0;
                var key;
                while (names.length > i) {
                    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
                } return result;
            };

// 19.4.1.1 Symbol([description])
            if (!USE_NATIVE) {
                $Symbol = function Symbol() {
                    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
                    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
                    var $set = function (value) {
                        if (this === ObjectProto) $set.call(OPSymbols, value);
                        if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
                        setSymbolDesc(this, tag, createDesc(1, value));
                    };
                    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
                    return wrap(tag);
                };
                redefine($Symbol[PROTOTYPE], 'toString', function toString() {
                    return this._k;
                });

                $GOPD.f = $getOwnPropertyDescriptor;
                $DP.f = $defineProperty;
                __webpack_require__(37).f = gOPNExt.f = $getOwnPropertyNames;
                __webpack_require__(27).f = $propertyIsEnumerable;
                __webpack_require__(36).f = $getOwnPropertySymbols;

                if (DESCRIPTORS && !__webpack_require__(17)) {
                    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
                }

                wksExt.f = function (name) {
                    return wrap(wks(name));
                };
            }

            $export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

            for (var es6Symbols = (
                // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
                'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
            ).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

            for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

            $export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
                // 19.4.2.1 Symbol.for(key)
                'for': function (key) {
                    return has(SymbolRegistry, key += '')
                        ? SymbolRegistry[key]
                        : SymbolRegistry[key] = $Symbol(key);
                },
                // 19.4.2.5 Symbol.keyFor(sym)
                keyFor: function keyFor(sym) {
                    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
                    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
                },
                useSetter: function () { setter = true; },
                useSimple: function () { setter = false; }
            });

            $export($export.S + $export.F * !USE_NATIVE, 'Object', {
                // 19.1.2.2 Object.create(O [, Properties])
                create: $create,
                // 19.1.2.4 Object.defineProperty(O, P, Attributes)
                defineProperty: $defineProperty,
                // 19.1.2.3 Object.defineProperties(O, Properties)
                defineProperties: $defineProperties,
                // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
                getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
                // 19.1.2.7 Object.getOwnPropertyNames(O)
                getOwnPropertyNames: $getOwnPropertyNames,
                // 19.1.2.8 Object.getOwnPropertySymbols(O)
                getOwnPropertySymbols: $getOwnPropertySymbols
            });

// 24.3.2 JSON.stringify(value [, replacer [, space]])
            $JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
                var S = $Symbol();
                // MS Edge converts symbol values to JSON as {}
                // WebKit converts symbol values to JSON as null
                // V8 throws on boxed symbols
                return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
            })), 'JSON', {
                stringify: function stringify(it) {
                    var args = [it];
                    var i = 1;
                    var replacer, $replacer;
                    while (arguments.length > i) args.push(arguments[i++]);
                    $replacer = replacer = args[1];
                    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
                    if (!isArray(replacer)) replacer = function (key, value) {
                        if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
                        if (!isSymbol(value)) return value;
                    };
                    args[1] = replacer;
                    return _stringify.apply($JSON, args);
                }
            });

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
            $Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(5)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
            setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
            setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
            setToStringTag(global.JSON, 'JSON', true);


            /***/ }),
        /* 68 */
        /***/ (function(module, exports, __webpack_require__) {

            var META = __webpack_require__(13)('meta');
            var isObject = __webpack_require__(6);
            var has = __webpack_require__(3);
            var setDesc = __webpack_require__(1).f;
            var id = 0;
            var isExtensible = Object.isExtensible || function () {
                return true;
            };
            var FREEZE = !__webpack_require__(11)(function () {
                return isExtensible(Object.preventExtensions({}));
            });
            var setMeta = function (it) {
                setDesc(it, META, { value: {
                    i: 'O' + ++id, // object ID
                    w: {}          // weak collections IDs
                } });
            };
            var fastKey = function (it, create) {
                // return primitive with prefix
                if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
                if (!has(it, META)) {
                    // can't set metadata to uncaught frozen object
                    if (!isExtensible(it)) return 'F';
                    // not necessary to add metadata
                    if (!create) return 'E';
                    // add missing metadata
                    setMeta(it);
                    // return object ID
                } return it[META].i;
            };
            var getWeak = function (it, create) {
                if (!has(it, META)) {
                    // can't set metadata to uncaught frozen object
                    if (!isExtensible(it)) return true;
                    // not necessary to add metadata
                    if (!create) return false;
                    // add missing metadata
                    setMeta(it);
                    // return hash weak collections IDs
                } return it[META].w;
            };
// add metadata on freeze-family methods calling
            var onFreeze = function (it) {
                if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
                return it;
            };
            var meta = module.exports = {
                KEY: META,
                NEED: false,
                fastKey: fastKey,
                getWeak: getWeak,
                onFreeze: onFreeze
            };


            /***/ }),
        /* 69 */
        /***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
            var getKeys = __webpack_require__(20);
            var gOPS = __webpack_require__(36);
            var pIE = __webpack_require__(27);
            module.exports = function (it) {
                var result = getKeys(it);
                var getSymbols = gOPS.f;
                if (getSymbols) {
                    var symbols = getSymbols(it);
                    var isEnum = pIE.f;
                    var i = 0;
                    var key;
                    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
                } return result;
            };


            /***/ }),
        /* 70 */
        /***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
            var cof = __webpack_require__(35);
            module.exports = Array.isArray || function isArray(arg) {
                return cof(arg) == 'Array';
            };


            /***/ }),
        /* 71 */
        /***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
            var toIObject = __webpack_require__(7);
            var gOPN = __webpack_require__(37).f;
            var toString = {}.toString;

            var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
                ? Object.getOwnPropertyNames(window) : [];

            var getWindowNames = function (it) {
                try {
                    return gOPN(it);
                } catch (e) {
                    return windowNames.slice();
                }
            };

            module.exports.f = function getOwnPropertyNames(it) {
                return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
            };


            /***/ }),
        /* 72 */
        /***/ (function(module, exports) {



            /***/ }),
        /* 73 */
        /***/ (function(module, exports, __webpack_require__) {

            __webpack_require__(26)('asyncIterator');


            /***/ }),
        /* 74 */
        /***/ (function(module, exports, __webpack_require__) {

            __webpack_require__(26)('observable');


            /***/ }),
        /* 75 */
        /***/ (function(module, exports, __webpack_require__) {

            "use strict";


            exports.__esModule = true;

            var _setPrototypeOf = __webpack_require__(76);

            var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

            var _create = __webpack_require__(80);

            var _create2 = _interopRequireDefault(_create);

            var _typeof2 = __webpack_require__(31);

            var _typeof3 = _interopRequireDefault(_typeof2);

            function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

            exports.default = function (subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) {
                    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
                }

                subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
            };

            /***/ }),
        /* 76 */
        /***/ (function(module, exports, __webpack_require__) {

            module.exports = { "default": __webpack_require__(77), __esModule: true };

            /***/ }),
        /* 77 */
        /***/ (function(module, exports, __webpack_require__) {

            __webpack_require__(78);
            module.exports = __webpack_require__(4).Object.setPrototypeOf;


            /***/ }),
        /* 78 */
        /***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
            var $export = __webpack_require__(9);
            $export($export.S, 'Object', { setPrototypeOf: __webpack_require__(79).set });


            /***/ }),
        /* 79 */
        /***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
            /* eslint-disable no-proto */
            var isObject = __webpack_require__(6);
            var anObject = __webpack_require__(10);
            var check = function (O, proto) {
                anObject(O);
                if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
            };
            module.exports = {
                set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
                    function (test, buggy, set) {
                        try {
                            set = __webpack_require__(28)(Function.call, __webpack_require__(38).f(Object.prototype, '__proto__').set, 2);
                            set(test, []);
                            buggy = !(test instanceof Array);
                        } catch (e) { buggy = true; }
                        return function setPrototypeOf(O, proto) {
                            check(O, proto);
                            if (buggy) O.__proto__ = proto;
                            else set(O, proto);
                            return O;
                        };
                    }({}, false) : undefined),
                check: check
            };


            /***/ }),
        /* 80 */
        /***/ (function(module, exports, __webpack_require__) {

            module.exports = { "default": __webpack_require__(81), __esModule: true };

            /***/ }),
        /* 81 */
        /***/ (function(module, exports, __webpack_require__) {

            __webpack_require__(82);
            var $Object = __webpack_require__(4).Object;
            module.exports = function create(P, D) {
                return $Object.create(P, D);
            };


            /***/ }),
        /* 82 */
        /***/ (function(module, exports, __webpack_require__) {

            var $export = __webpack_require__(9);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
            $export($export.S, 'Object', { create: __webpack_require__(19) });


            /***/ }),
        /* 83 */
        /***/ (function(module, exports) {

            module.exports = __WEBPACK_EXTERNAL_MODULE_83__;

            /***/ }),
        /* 84 */
        /***/ (function(module, exports) {

            module.exports = "<button data-level-selector-button>\n  Auto\n</button>\n<ul>\n  <% if (title) { %>\n  <li data-title><%= title %></li>\n  <% }; %>\n  <li><a href=\"#\" data-level-selector-select=\"-1\">AUTO</a></li>\n  <% for (var i = 0; i < levels.length; i++) { %>\n    <li><a href=\"#\" data-level-selector-select=\"<%= levels[i].id %>\"><%= levels[i].label %></a></li>\n  <% }; %>\n</ul>\n";

            /***/ }),
        /* 85 */
        /***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
            var content = __webpack_require__(86);
            if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
            var update = __webpack_require__(88)(content, {"singleton":true});
            if(content.locals) module.exports = content.locals;
// Hot Module Replacement
            if(false) {
                // When the styles change, update the <style> tags
                if(!content.locals) {
                    module.hot.accept("!!../../node_modules/css-loader/index.js!../../node_modules/postcss-loader/lib/index.js!../../node_modules/sass-loader/lib/loader.js?includePaths[]=/Users/bruno/workspace/player/clappr/clappr-level-selector-plugin/node_modules/compass-mixins/lib&includePaths[]=/Users/bruno/workspace/player/clappr/clappr-level-selector-plugin/node_modules/clappr/src/base/scss&includePaths[]=/Users/bruno/workspace/player/clappr/clappr-level-selector-plugin/src/base/scss!./style.scss", function() {
                        var newContent = require("!!../../node_modules/css-loader/index.js!../../node_modules/postcss-loader/lib/index.js!../../node_modules/sass-loader/lib/loader.js?includePaths[]=/Users/bruno/workspace/player/clappr/clappr-level-selector-plugin/node_modules/compass-mixins/lib&includePaths[]=/Users/bruno/workspace/player/clappr/clappr-level-selector-plugin/node_modules/clappr/src/base/scss&includePaths[]=/Users/bruno/workspace/player/clappr/clappr-level-selector-plugin/src/base/scss!./style.scss");
                        if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
                        update(newContent);
                    });
                }
                // When the module is disposed, remove the <style> tags
                module.hot.dispose(function() { update(); });
            }

            /***/ }),
        /* 86 */
        /***/ (function(module, exports, __webpack_require__) {

            exports = module.exports = __webpack_require__(87)(false);
// imports


// module
            exports.push([module.i, ".level_selector[data-level-selector] {\n  float: right;\n  position: relative;\n  height: 100%; }\n  .level_selector[data-level-selector] button {\n    background-color: transparent;\n    color: #fff;\n    font-family: Roboto,\"Open Sans\",Arial,sans-serif;\n    -webkit-font-smoothing: antialiased;\n    border: none;\n    font-size: 10px;\n    height: 100%; }\n    .level_selector[data-level-selector] button:hover {\n      color: #c9c9c9; }\n    .level_selector[data-level-selector] button.changing {\n      -webkit-animation: pulse 0.5s infinite alternate; }\n  .level_selector[data-level-selector] > ul {\n    list-style-type: none;\n    position: absolute;\n    bottom: 100%;\n    border: 1px solid black;\n    display: none;\n    background-color: #e6e6e6;\n    white-space: nowrap; }\n  .level_selector[data-level-selector] li {\n    font-size: 10px; }\n    .level_selector[data-level-selector] li[data-title] {\n      background-color: #c3c2c2;\n      padding: 5px; }\n    .level_selector[data-level-selector] li a {\n      color: #444;\n      padding: 2px 10px;\n      display: block;\n      text-decoration: none; }\n      .level_selector[data-level-selector] li a:hover {\n        background-color: #555;\n        color: white; }\n        .level_selector[data-level-selector] li a:hover a {\n          color: white;\n          text-decoration: none; }\n    .level_selector[data-level-selector] li.current a {\n      color: #f00; }\n", ""]);

// exports


            /***/ }),
        /* 87 */
        /***/ (function(module, exports) {

            /*
                MIT License http://www.opensource.org/licenses/mit-license.php
                Author Tobias Koppers @sokra
            */
// css base code, injected by the css-loader
            module.exports = function(useSourceMap) {
                var list = [];

                // return the list of modules as css string
                list.toString = function toString() {
                    return this.map(function (item) {
                        var content = cssWithMappingToString(item, useSourceMap);
                        if(item[2]) {
                            return "@media " + item[2] + "{" + content + "}";
                        } else {
                            return content;
                        }
                    }).join("");
                };

                // import a list of modules into the list
                list.i = function(modules, mediaQuery) {
                    if(typeof modules === "string")
                        modules = [[null, modules, ""]];
                    var alreadyImportedModules = {};
                    for(var i = 0; i < this.length; i++) {
                        var id = this[i][0];
                        if(typeof id === "number")
                            alreadyImportedModules[id] = true;
                    }
                    for(i = 0; i < modules.length; i++) {
                        var item = modules[i];
                        // skip already imported module
                        // this implementation is not 100% perfect for weird media query combinations
                        //  when a module is imported multiple times with different media queries.
                        //  I hope this will never occur (Hey this way we have smaller bundles)
                        if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
                            if(mediaQuery && !item[2]) {
                                item[2] = mediaQuery;
                            } else if(mediaQuery) {
                                item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
                            }
                            list.push(item);
                        }
                    }
                };
                return list;
            };

            function cssWithMappingToString(item, useSourceMap) {
                var content = item[1] || '';
                var cssMapping = item[3];
                if (!cssMapping) {
                    return content;
                }

                if (useSourceMap && typeof btoa === 'function') {
                    var sourceMapping = toComment(cssMapping);
                    var sourceURLs = cssMapping.sources.map(function (source) {
                        return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */'
                    });

                    return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
                }

                return [content].join('\n');
            }

// Adapted from convert-source-map (MIT)
            function toComment(sourceMap) {
                // eslint-disable-next-line no-undef
                var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
                var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

                return '/*# ' + data + ' */';
            }


            /***/ }),
        /* 88 */
        /***/ (function(module, exports) {

            /*
                MIT License http://www.opensource.org/licenses/mit-license.php
                Author Tobias Koppers @sokra
            */
            var stylesInDom = {},
                memoize = function(fn) {
                    var memo;
                    return function () {
                        if (typeof memo === "undefined") memo = fn.apply(this, arguments);
                        return memo;
                    };
                },
                isOldIE = memoize(function() {
                    return /msie [6-9]\b/.test(window.navigator.userAgent.toLowerCase());
                }),
                getHeadElement = memoize(function () {
                    return document.head || document.getElementsByTagName("head")[0];
                }),
                singletonElement = null,
                singletonCounter = 0;

            module.exports = function(list, options) {
                if(typeof DEBUG !== "undefined" && DEBUG) {
                    if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
                }

                options = options || {};
                // Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
                // tags it will allow on a page
                if (typeof options.singleton === "undefined") options.singleton = isOldIE();

                var styles = listToStyles(list);
                addStylesToDom(styles, options);

                return function update(newList) {
                    var mayRemove = [];
                    for(var i = 0; i < styles.length; i++) {
                        var item = styles[i];
                        var domStyle = stylesInDom[item.id];
                        domStyle.refs--;
                        mayRemove.push(domStyle);
                    }
                    if(newList) {
                        var newStyles = listToStyles(newList);
                        addStylesToDom(newStyles, options);
                    }
                    for(var i = 0; i < mayRemove.length; i++) {
                        var domStyle = mayRemove[i];
                        if(domStyle.refs === 0) {
                            for(var j = 0; j < domStyle.parts.length; j++)
                                domStyle.parts[j]();
                            delete stylesInDom[domStyle.id];
                        }
                    }
                };
            }

            function addStylesToDom(styles, options) {
                for(var i = 0; i < styles.length; i++) {
                    var item = styles[i];
                    var domStyle = stylesInDom[item.id];
                    if(domStyle) {
                        domStyle.refs++;
                        for(var j = 0; j < domStyle.parts.length; j++) {
                            domStyle.parts[j](item.parts[j]);
                        }
                        for(; j < item.parts.length; j++) {
                            domStyle.parts.push(addStyle(item.parts[j], options));
                        }
                    } else {
                        var parts = [];
                        for(var j = 0; j < item.parts.length; j++) {
                            parts.push(addStyle(item.parts[j], options));
                        }
                        stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
                    }
                }
            }

            function listToStyles(list) {
                var styles = [];
                var newStyles = {};
                for(var i = 0; i < list.length; i++) {
                    var item = list[i];
                    var id = item[0];
                    var css = item[1];
                    var media = item[2];
                    var sourceMap = item[3];
                    var part = {css: css, media: media, sourceMap: sourceMap};
                    if(!newStyles[id])
                        styles.push(newStyles[id] = {id: id, parts: [part]});
                    else
                        newStyles[id].parts.push(part);
                }
                return styles;
            }

            function createStyleElement() {
                var styleElement = document.createElement("style");
                var head = getHeadElement();
                styleElement.type = "text/css";
                head.appendChild(styleElement);
                return styleElement;
            }

            function createLinkElement() {
                var linkElement = document.createElement("link");
                var head = getHeadElement();
                linkElement.rel = "stylesheet";
                head.appendChild(linkElement);
                return linkElement;
            }

            function addStyle(obj, options) {
                var styleElement, update, remove;

                if (options.singleton) {
                    var styleIndex = singletonCounter++;
                    styleElement = singletonElement || (singletonElement = createStyleElement());
                    update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
                    remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
                } else if(obj.sourceMap &&
                    typeof URL === "function" &&
                    typeof URL.createObjectURL === "function" &&
                    typeof URL.revokeObjectURL === "function" &&
                    typeof Blob === "function" &&
                    typeof btoa === "function") {
                    styleElement = createLinkElement();
                    update = updateLink.bind(null, styleElement);
                    remove = function() {
                        styleElement.parentNode.removeChild(styleElement);
                        if(styleElement.href)
                            URL.revokeObjectURL(styleElement.href);
                    };
                } else {
                    styleElement = createStyleElement();
                    update = applyToTag.bind(null, styleElement);
                    remove = function() {
                        styleElement.parentNode.removeChild(styleElement);
                    };
                }

                update(obj);

                return function updateStyle(newObj) {
                    if(newObj) {
                        if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
                            return;
                        update(obj = newObj);
                    } else {
                        remove();
                    }
                };
            }

            var replaceText = (function () {
                var textStore = [];

                return function (index, replacement) {
                    textStore[index] = replacement;
                    return textStore.filter(Boolean).join('\n');
                };
            })();

            function applyToSingletonTag(styleElement, index, remove, obj) {
                var css = remove ? "" : obj.css;

                if (styleElement.styleSheet) {
                    styleElement.styleSheet.cssText = replaceText(index, css);
                } else {
                    var cssNode = document.createTextNode(css);
                    var childNodes = styleElement.childNodes;
                    if (childNodes[index]) styleElement.removeChild(childNodes[index]);
                    if (childNodes.length) {
                        styleElement.insertBefore(cssNode, childNodes[index]);
                    } else {
                        styleElement.appendChild(cssNode);
                    }
                }
            }

            function applyToTag(styleElement, obj) {
                var css = obj.css;
                var media = obj.media;
                var sourceMap = obj.sourceMap;

                if(media) {
                    styleElement.setAttribute("media", media)
                }

                if(styleElement.styleSheet) {
                    styleElement.styleSheet.cssText = css;
                } else {
                    while(styleElement.firstChild) {
                        styleElement.removeChild(styleElement.firstChild);
                    }
                    styleElement.appendChild(document.createTextNode(css));
                }
            }

            function updateLink(linkElement, obj) {
                var css = obj.css;
                var media = obj.media;
                var sourceMap = obj.sourceMap;

                if(sourceMap) {
                    // http://stackoverflow.com/a/26603875
                    css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
                }

                var blob = new Blob([css], { type: "text/css" });

                var oldSrc = linkElement.href;

                linkElement.href = URL.createObjectURL(blob);

                if(oldSrc)
                    URL.revokeObjectURL(oldSrc);
            }


            /***/ })
        /******/ ]);
});


// WEBPACK FOOTER //
// ./src/components/ClapprPlayer/level-selector.js